<template>
  <div class="row">
    <!-- <GDMap></GDMap> -->
    <div style="position: relative;width: 100%;height: 100%;">
      <div id="container" class="map" :style="{height:mapheight}"></div>
      <!-- <div id="container" style="width:100%; height:100%"></div> -->
      <div id="panel" v-show="panel"></div>
      <div id="busInfo" v-show="busInfo"></div>

      <div class="roadPlanWindow">
        <div class="roadPlanWindowHead">
          <span class></span>
          <span style="color:#fff;margin-left:10px;">公交出行规划</span>
          <!-- <span id="byCar" class="iconfont" title="驾车">&#xe661;</span> -->
          <!-- <span id="byBus" class="iconfont" title="公交">&#xe84c;</span> -->
          <!-- <span id="byWalk" class="iconfont" title="步行">&#xe636;</span> -->
          <!-- <span id="closeBtn" class="iconfont" @click="closeWindow()">&#xe600;</span> -->
        </div>

        <div class="roadPlanWindowMid">
          <div>
            <span class="iconfont">&#xe7b4;</span>
          </div>
          <div class="roadPlanWindowMidInput">
            <el-input placeholder="请输入起点" v-model="start" clearable size="mini"></el-input>
            <el-input placeholder="请输入终点" v-model="end" clearable size="mini"></el-input>
          </div>
        </div>

        <div>
          <!-- <button type="button" class="btn  btn-danger" @click="getBusInfo">去这里</button> -->
          <el-button type="danger" @click="getBusInfo" size="mini">去这里</el-button>
        </div>
      </div>
      <!-- <div id="myPageTop" v-show="tipBarStatus">
        <input v-model="input" id="tipinput" placeholder="请输入关键词">
        <button @click="searchAddress">搜索</button>
        <button @click="openWindow">
          <span class="iconfont">&#xe610;</span>
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
var map, placeSearch, transfer;
export default {
  name: "Bmquery",
  data() {
    return {
      input: "",
      windowStatus: false,
      tipBarStatus: true,
      panel: false,
      busInfo: false,
      start: "",
      end: ""
    };
  },
  props: {
    mapheight: {
      type: String,
      default: "700px"
    }
  },
  components: {},
  mounted() {
    this.AMapInit();
    this.is_route_params_null();
  },
  methods: {
    is_route_params_null() {
      if (JSON.stringify(this.$route.params) != "{}") {
        this.start = this.$route.params.start;
        this.end = this.$route.params.end;
        this.getBusInfo();
      }
    },
    AMapInit() {
      map = new AMap.Map("container", {
        resizeEnable: true,
        center: [109.874216,39.723309],
        zoom: 11,
        mapStyle: "amap://styles/98b70c148d3711c97abe884acb2aacde"
      });
      var trafficLayer = new AMap.TileLayer.Traffic({
        zIndex: 10
      });
      trafficLayer.setMap(map);
      AMap.service(["AMap.PlaceSearch"], function() {
        //构造地点查询类
        placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: "0477",
          citylimit: true, //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          renderStyle: "default"
        });
      });
      //公交路线规划
      var transOptions = {
        map: map,
        city: "鄂尔多斯市",
        panel: "busInfo",
        policy: AMap.TransferPolicy.LEAST_TIME //乘车策略
      };
      //构造公交换乘类
      transfer = new AMap.Transfer(transOptions);
    },
    searchAddress() {
      this.panel = true;
      if (this.input == "") {
        return;
      }
      placeSearch.search(this.input);
    },
    getBusInfo() {
      this.busInfo = true;
      transfer.search([
        { keyword: this.start, city: "鄂尔多斯" },
        //第一个元素city缺省时取transOptions的city属性
        { keyword: this.end, city: "鄂尔多斯" }
        //第二个元素city缺省时取transOptions的cityd属性
      ]);
    },
    openWindow() {
      this.AMapInit();
      this.tipBarStatus = false;
      this.windowStatus = true;
      this.panel = false;
    },
    closeWindow() {
      this.AMapInit();
      this.busInfo = false;
      this.tipBarStatus = true;
      this.windowStatus = false;
    }
  }
};
</script>

<style scoped>
.row {
  padding: 0 5px 10px 5px;
}
.map {
  height: 100%;
  border: 1px solid #ccc;
}
#panel {
  position: absolute;
  background-color: red;
  max-height: 90%;
  overflow-y: auto;
  top: 10.2%;
  left: 20px;
  width: 25%;
  box-shadow: 2px 2px 2px #ccc;
}
#busInfo {
  position: absolute;
  background-color: red;
  max-height: 70%;
  overflow-y: auto;
  top: 185px;
  left: 20px;
  width: 25%;
  box-shadow: 2px 2px 2px #ccc;
}
#myPageTop {
  position: absolute;
  display: flex;
  height: 5%;
  width: 25%;
  top: 5%;
  left: 20px;
  box-shadow: 2px 2px 2px #ccc;
}
#myPageTop input {
  flex: 1;
  font-size: 14px;
}
#myPageTop button:nth-child(2) {
  width: 20%;
  color: white;
  border: none;
  border: 1px solid #ccc;
  background-color: rgba(1, 152, 251, 1);
  /* color: rebeccapurple; */
}
#myPageTop button:nth-child(3) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12%;
  color: white;
  border: none;
  border: 1px solid #ccc;
  background-color: rgba(1, 152, 251, 1);
  font-size: 20px;
  font-weight: bold;
  /* color: rebeccapurple; */
}
.roadPlanWindow {
  position: absolute;
  top: 5%;
  left: 20px;
  width: 25%;
  height: 150px;
  background-color: rgba(1, 152, 251, 1);
}
.roadPlanWindowHead {
  /* border:1px solid red; */
  height: 25%;
  display: flex;
}
.roadPlanWindowHeadNull {
  flex: 1;
}
.iconfont {
  color: white;
}
.roadPlanWindowHead .iconfont {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14%;
  font-size: 22px;
}
.roadPlanWindowHead .iconfont:hover {
  cursor: pointer;
}
#byCar {
  font-size: 26px;
}
#closeBtn {
  margin-right: 0;
  display: block;
  width: 12%;
  line-height: 30px;
  font-size: 14px;
}
.roadPlanWindowMid {
  padding-right: 20px;
  width: 100%;
  /* border: 1px solid red; */
  display: flex;
}
.roadPlanWindowMid div:nth-child(1) {
  display: flex;
  align-items: center;
}
.roadPlanWindowMid .iconfont {
  font-size: 24px;
  font-weight: 100;
}
.roadPlanWindowMidInput {
  /* border: 1px solid red; */
  flex: 1;
  font-size: 14px;
}
.roadPlanWindowMidInput .el-input {
  margin-bottom: 3px;
}
.roadPlanWindowMidInput .el-input:nth-child(2) {
  margin-bottom: 0;
}
.roadPlanWindow div:nth-child(3) {
  margin-top: 10px;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/bmquery/index.vue


// WEBPACK FOOTER //
// src/pages/bmquery/index.vue